import React from 'react';

export default function CheckedCheckboxIcon({ className, onClick }) {
	return (
		<svg className={className}
			onClick={onClick}
			width="32"
			height="32"
			viewBox="0 0 32 32"
			fill="none"
			xmlns="http://www.w3.org/2000/svg">
			<rect x="4"
				y="4"
				width="24"
				height="24"
				rx="4"
				fill="#B3FE00"/>
			<path d="M13.3332 22.6668L6.6665 16.0001L8.5465 14.1201L13.3332 18.8934L23.4532 8.77344L25.3332 10.6668L13.3332 22.6668Z"
				fill="black"/>
		</svg>
    
	);
}
